export const L10ManageMembers = /** @type {const} */ ({
  filterbyRoleType: 'Filter by Role',
  filterByLicenseType: 'Filter by License',
  filterByAddon: 'Filter by Addon',
  filterByTeamType: 'Filter by Team',
  noTeam: 'No Team',
  noTeamDescription: 'Members not a part of any team',
  filterByDialers: 'Filter by Dialer',
  meetingPrivacy: 'Meeting Privacy',
  filterByMeetingPrivacy: 'Filter by Meeting Privacy',
  visibleToOrganization: 'Visible to Organization',
  privateToMember: 'Private to Participants',
  primaryTeamAccess: 'Visible to Specific Teams',
  searchForAMember: 'Search for a member'
});
